<template>
    <div style="padding:12px">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button size="medium" type="primary" @click="onsave">保存</el-button>
        </div>
        <div class="content">
            <div style="width: 810px;padding-top:20px;margin: 0 auto;">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="角色常量标识" prop="constantId">
                        <el-input :readonly="isEdit" v-model="formData.constantId" :maxlength="20" placeholder="请输入数字"></el-input>
                    </el-form-item>
                    <el-form-item label="角色名称" prop="name">
                        <el-input v-model="formData.name" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="是否可选" prop="isChoose">
                        <el-radio-group v-model="formData.isChoose">
                            <el-radio :label="1">可选</el-radio>
                            <el-radio :label="2">不可选</el-radio>
                            <el-radio :label="3">不可选但默认</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否可选" prop="ynDelete">
                        <el-radio-group v-model="formData.ynDelete">
                            <el-radio :label="1">可删</el-radio>
                            <el-radio :label="2">不可删</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="所属系统" prop="platformType">
                        <el-select v-model="formData.platformType" placeholder="请选择">
                            <el-option v-for="item in platformTypeList" :key="item.code" :label="item.value"
                                       :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';
    import {insertRoleInfo, updateRoleInfo, queryRoleInfo, queryRoleTypeFromDict} from '@/api/role';
    import {getDicByCode} from '@/utils/utils';

    export default {
        name: "roleAddEdit",
        components: {BackTool},
        data() {
            const validateConstantId = (rule, value, callback) => {
                value = `${value}`.trim();
                if (value === '') {
                    callback(new Error('角色常量标识不能为空'));
                } else if(!/^\d+$/.test(value)) {
                    callback(new Error('请输入数字'));
                } else {
                    callback();
                }
            };

            return {
                isEdit: !!this.$route.query.id,
                id: this.$route.query.id,
                platformTypeList: [],
                formData: {
                    constantId: '',
                    isChoose: 1,
                    name: '',
                    platformType: 1,
                    ynDelete: 1,
                },
                rules: {
                    constantId: [
                        {required: true, validator: validateConstantId}
                    ],
                    name: [
                        { required: true, message: '请输入角色名称', trigger: 'blur' },
                    ],
                    isChoose: [
                        { required: true, message: '请选择是否可选', trigger: 'blur' },
                    ],
                    ynDelete: [
                        { required: true, message: '请选择是否可删', trigger: 'blur' },
                    ],
                    platformType: [
                        { required: true, message: '请选择所属系统', trigger: 'blur' },
                    ],
                },
            }
        },
        created() {
            getDicByCode('roleSystem')
                .then(data => {
                    this.platformTypeList = data;
                    if(data && data.length !== 0) {
                        this.formData.platformType = data[0].code;
                    }
                });
            if(this.isEdit) {
                queryRoleInfo({
                    id: this.id
                })
                    .then(data => {
                        data.platformType = `${data.platformType}`;
                        this.formData = data;
                    });
            }
        },
        methods: {
            onsave() {
                this.$refs.form.validate(isValid => {
                    if(isValid) {
                        const args = {
                            constantId: this.formData.constantId,
                            isChoose: this.formData.isChoose,
                            name: this.formData.name,
                            platformType: this.formData.platformType,
                            ynDelete: this.formData.ynDelete,
                        };
                        new Promise(resolve => {
                            if(this.isEdit) {
                                args.id = this.id;
                                updateRoleInfo(args).then(resolve)
                            } else {
                                insertRoleInfo(args).then(resolve)
                            }
                        })
                            .then(() => {
                                this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
                                window.setTimeout(() => {
                                    this.$router.back();
                                }, 500);
                            })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/permissionSystem/role/roleAddEdit.vue